import apiClient from '@/api/client'
import { Dictionary } from '@/types/field'
export default class AnalysisAPI {

    // User API
    static analysisList(payload: Dictionary) {
        return apiClient.post('/image/analysis-history', payload)
    }

    static analysisGet(id: string) {
        return apiClient.get(`/image/analysis-history/${id}`)
    }

}

